import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styled from 'styled-components';

const NotificationDiv = styled.div`
  display: ${props => (props.messageBody ? 'block' : 'inline-block')};
  background: ${props => props.primaryColor};
  border: 2px solid ${props => props.secondaryColor};
  border-radius: 5px;

  padding: 4px 8px;
  margin-bottom: 16px;
  margin-left: ${props => props.leftMargin + 'px'};
  margin-right: ${props => props.rightMargin + 'px'};

  font-size: 14px;
  font-weight: 600;
  text-align: ${({ messageBody, alignLeft }) =>
    messageBody || alignLeft ? 'left' : 'center'};

  color: ${props => props.textColor};

  width: ${({ width }) => {
    if (width) {
      if (width.toString().search('%') === -1) {
        return width + 'px';
      } else {
        return width;
      }
    }
    return 'auto';
  }};
`;

const NotificationText = styled.span`
  margin: 0 8px;
`;

const NotificationLink = styled.div`
  display: inline-block;
  font-size: 14px;
  font-weight: 800;
  color: ${props => props.secondaryColor};
  text-decoration: underline !important;

  :hover {
    cursor: pointer;
  }
`;

const NotificationBody = styled.div`
  margin-top: 8px;
  font-weight: normal;
`;

const Notification = ({
  type,
  icon,
  message,
  linkMessage,
  onClick,
  messageBody,
  leftMargin,
  rightMargin,
  width,
  alignLeft
}) => {
  let primaryColor = '#C2E8D8';
  let secondaryColor = '#735C0F';
  let textColor = secondaryColor;

  if (type === 'alert') {
    primaryColor = '#FFEA7F';
    secondaryColor = '#524E0F';
    textColor = '#735C0F';
  } else if (type === 'danger') {
    primaryColor = '#F5C0BA';
    secondaryColor = '#9B2012';
    textColor = secondaryColor;
  } else if (type === 'info') {
    primaryColor = '#B2DFFF';
    secondaryColor = '#005999';
    textColor = secondaryColor;
  }

  const iconNode = !icon ? null : (
    <FontAwesomeIcon data-testid="notification-icon" icon={icon} />
  );

  const linkNode =
    !linkMessage || !onClick ? null : (
      <NotificationLink {...{ secondaryColor, onClick }}>
        {linkMessage}
      </NotificationLink>
    );

  return (
    <NotificationDiv
      {...{
        primaryColor,
        secondaryColor,
        textColor,
        messageBody,
        leftMargin,
        rightMargin,
        width,
        alignLeft
      }}
    >
      <div>
        {iconNode}
        <NotificationText>{message}</NotificationText>
        {linkNode}
      </div>
      {messageBody && <NotificationBody>{messageBody}</NotificationBody>}
    </NotificationDiv>
  );
};

Notification.propTypes = {
  type: PropTypes.oneOf(['success', 'alert', 'danger', 'info']).isRequired,
  icon: PropTypes.object,
  message: PropTypes.string.isRequired,
  linkMessage: PropTypes.string,
  onClick: PropTypes.func,
  messageBody: PropTypes.string,
  rightMargin: PropTypes.number,
  leftMargin: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  alignLeft: PropTypes.bool
};

Notification.defaultProps = {
  rightMargin: 0,
  leftMargin: 0,
  alignLeft: false
};

export default Notification;
